'use client';

import React from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import type { AttrDef } from '../model/moving-item.types';

export interface AttrValueInputProps {
  attr: AttrDef;
  value: string;
  onChange: (value: string) => void;
}

export function AttrValueInput({ attr, value, onChange }: AttrValueInputProps) {
  const label = attr.name ?? attr.key;

  if (attr.type === 'ENUM' && attr.values) {
    return (
      <FormControl fullWidth size="small">
        <InputLabel>{label}</InputLabel>
        <Select label={label} value={value} onChange={(e) => onChange(e.target.value)}>
          <MenuItem value="">
            <em>선택</em>
          </MenuItem>
          {attr.values.map((v) => (
            <MenuItem key={v} value={v}>
              {attr.enumDisplayNames?.[v] ?? v}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  return (
    <TextField
      label={label}
      size="small"
      fullWidth
      type={attr.type === 'NUMBER' ? 'number' : 'text'}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={attr.type === 'NUMBER' ? '숫자 입력' : '입력'}
    />
  );
}
